// Stato dell'SDK Facebook condiviso fra le istanze del modulo: sulla stessa pagina ne
// convivono piu' d'una (trovacigusto, header della home) e master-homepage carica
// questo file due volte, ma lo script va inserito e inizializzato una volta sola.
window.tgFacebookSdk = window.tgFacebookSdk || { promise: null, ready: false }

function FacebookModule () {
  var self = this

  self.user = ko.observable(null)
  self.loading = ko.observable(false)
  self.image = ko.observable(null)
  self.registerType = ko.observable(null)
  self.invitationCode = ko.observable(null)

  /**
   * Remote logging per debug login Facebook su iOS/GoNative.
   * 
   * IMPORTANTE: NON CANCELLARE - Usato per debug login Facebook (Dicembre 2025).
   * Per riabilitare: decommentare il corpo della funzione.
   * Logs salvati in: app/storage/logs/YYYY-MM-DD/facebook.log
   */
  self.remoteLog = function(message, data) {
    // LOGGING DISABILITATO - Decommentare per debug
    return;
  }

  self.redirectCallback = function (redirectUrl) {
    location.href = redirectUrl
  }

  /**
   * Dopo il collegamento dall'app: si va avanti se e' riuscito o se il server indica dove andare.
   * Se e' fallito si resta sulla pagina con l'avviso (prima si tornava subito alla home e
   * l'avviso spariva: sembrava che il pulsante riportasse al login senza motivo).
   */
  self.redirectAfterBind = function (response) {
    if (self.bindSucceeded(response)) {
      self.redirectCallback(response.data && response.data.url ? response.data.url : '/')
    }
  }

  self.bindSucceeded = function (response) {
    return !!(response && (response.success || (response.data && response.data.url)))
  }

  /**
   * Avviso quando il server non collega l'account Facebook. L'email e' obbligatoria: senza (account
   * Facebook senza email o permesso negato) si dice cosa fare, invece del messaggio generico.
   */
  self.bindFailedMessage = function (response) {
    if (response && response.status === 'facebook.binding.email') {
      return 'Per accedere con Facebook serve l\'indirizzo email del tuo account Facebook. Riprova e consenti l\'accesso all\'email, oppure accedi con email e password.'
    }
    return 'Il tuo account Facebook non è stato collegato.'
  }

  /**
   * Nessun avviso se il server indica dove andare: per una nuova iscrizione senza email porta alla pagina
   * che chiede l'indirizzo (/login/facebook-email), che spiega da se'.
   */
  self.notifyBindFailure = function (response) {
    if (!(response && response.data && response.data.url)) {
      pNotify(self.bindFailedMessage(response), 'warning')
    }
  }

  /**
   * Carica l'SDK Facebook su richiesta.
   *
   * Prima veniva caricato su ogni pagina da front/includes/facebook.blade.php:
   * inizializzava con cookie:true e chiamava FB.AppEvents.logPageView(), quindi
   * tracciava anche chi non usa il login social e senza alcun consenso.
   * Caricandolo solo quando l'utente chiede di accedere (pre-caricamento al primo
   * segnale di intento, vedi LoginRegisterModule.preloadSocialSdks, o click su un
   * pulsante Facebook) diventa un servizio richiesto esplicitamente dall'utente.
   *
   * La configurazione (appId, FB.init) resta in facebook.blade.php, che definisce
   * window.fbAsyncInit: l'SDK la invoca da solo appena finisce di caricarsi.
   */
  self.loadSdk = function () {
    var sdk = window.tgFacebookSdk
    if (sdk.promise) {
      return sdk.promise
    }
    if (typeof FB !== 'undefined') {
      sdk.ready = true
      sdk.promise = Promise.resolve()
      return sdk.promise
    }

    sdk.promise = new Promise(function (resolve, reject) {
      var configuredInit = window.fbAsyncInit

      window.fbAsyncInit = function () {
        if (typeof configuredInit === 'function') {
          configuredInit()
        }
        sdk.ready = true
        resolve()
      }

      var script = document.createElement('script')
      script.async = true
      script.defer = true
      script.crossOrigin = 'anonymous'
      script.src = 'https://connect.facebook.net/it_IT/sdk.js'
      script.onerror = function () {
        sdk.promise = null
        reject(new Error('Facebook SDK non caricato'))
      }
      document.head.appendChild(script)
    })

    return sdk.promise
  }

  /**
   * Esegue fn con l'SDK disponibile. Se e' gia' pronto la chiama subito, ancora dentro
   * il click: FB.login apre un popup e i browser (Safari soprattutto) lo bloccano se non
   * parte in modo sincrono dal gesto dell'utente. Altrimenti carica e poi chiama.
   * Se il caricamento fallisce (rete, adblock) l'utente riceve un avviso invece di un
   * pulsante morto: senza questa guardia il ReferenceError finirebbe inghiottito da Knockout.
   */
  self.withSdk = function (fn) {
    if (window.tgFacebookSdk.ready) {
      fn()
      return
    }
    self.loadSdk()
      .then(fn)
      .catch(function () {
        pNotify('Accesso con Facebook non disponibile: non è stato possibile caricare lo script di Facebook. Controlla eventuali blocchi del browser.', 'warning')
      })
  }

  /**
   * FB.login apre un popup: se il browser lo blocca (chiamata partita fuori dal click,
   * per esempio perche' l'SDK ha finito di caricarsi dopo) si invita a riprovare.
   */
  self.openLoginPopup = function (callback, options) {
    var blocked = socialLoginPopupBlocked(function () {
      FB.login(callback, options)
    })
    if (blocked) {
      pNotify('Il browser ha bloccato la finestra di accesso con Facebook. Clicca di nuovo sul pulsante: ora è pronto. Se il blocco si ripete, consenti le finestre pop-up per questo sito.', 'warning')
    }
  }

  self.login = function () {
    self.withSdk(function () {
      self.openLoginPopup(function (response) {
        self.facebookLoginCallback(response)
      }, { scope: 'public_profile, email' })
    })
  }

  /**
   * Decodifica un JWT e restituisce il payload
   * Usato per Facebook Limited Login su iOS
   */
  self.decodeJWT = function (token) {
    try {
      var parts = token.split('.')
      if (parts.length !== 3) {
        self.remoteLog('JWT_DECODE_ERROR', {error: 'parts_count_not_3', parts_count: parts.length});
        return null
      }
      var payload = parts[1]
      // Converti da base64url a base64 standard
      payload = payload.replace(/-/g, '+').replace(/_/g, '/')
      // Aggiungi padding se necessario
      while (payload.length % 4) {
        payload += '='
      }
      var decoded = atob(payload)
      return JSON.parse(decoded)
    } catch (e) {
      self.remoteLog('JWT_DECODE_EXCEPTION', {error: e.toString()});
      return null
    }
  }

  self.facebookLoginCallback = function (response) {
    self.remoteLog('CALLBACK_START', {
      response_status: response ? response.status : 'null_response',
      response_type: response ? response.type : 'null_response',
      has_authResponse: response && response.authResponse ? true : false,
      limitedLogin: response ? response.limitedLogin : null,
      has_authToken: response && response.authToken ? true : false,
      has_accessToken: response && response.accessToken ? true : false,
      full_response: response
    });
    
    var accessToken
    var userId

    // Standard web login
    if (response.status === 'connected') {
      self.remoteLog('LOGIN_TYPE', {type: 'standard_web_connected'});
      accessToken = response.authResponse.accessToken
      userId = response.authResponse.userID
    } 
    // GoNative login
    else if (response.type === 'facebook') {
      self.remoteLog('LOGIN_TYPE', {
        type: 'gonative_facebook',
        limitedLogin: response.limitedLogin,
        has_authToken: !!response.authToken,
        has_accessToken: !!response.accessToken
      });
      
      // Login limitato (iOS senza consenso al tracciamento): il gettone da verificare e' authToken, un
      // JWT firmato da Facebook. Si usa ogni volta che c'e', anche se limitedLogin arriva false: in quel
      // caso l'accessToken dell'SDK iOS non e' leggibile e il server lo rifiuta (dal 16/10/2026 il
      // server verifica il gettone presso Facebook)
      if (response.authToken) {
        self.remoteLog('LIMITED_LOGIN_DETECTED', {authToken_length: response.authToken.length});
        
        // Limited Login: decodifica il JWT per ottenere i dati utente
        var jwtPayload = self.decodeJWT(response.authToken)
        
        if (jwtPayload) {
          self.remoteLog('JWT_DECODED_SUCCESS', {
            sub: jwtPayload.sub,
            email: jwtPayload.email,
            name: jwtPayload.name,
            given_name: jwtPayload.given_name,
            family_name: jwtPayload.family_name
          });
          self.handleLimitedLogin(jwtPayload, response.authToken)
          return
        } else {
          self.remoteLog('JWT_DECODE_FAILED', {});
          pNotify('Errore nella decodifica del token Facebook', 'error')
          return
        }
      }
      // Login classico dall'app (Android, o iOS con ATT): il gettone va direttamente al server, che dal
      // 16/10/2026 chiede id ed email a Facebook. Anche senza email in userDetails: prima si passava da
      // FB.api nel browser dell'app e, se l'email mancava, si tornava alla home senza un avviso chiaro
      if (response.accessToken) {
        self.remoteLog('GONATIVE_WITH_USERDETAILS', {
          has_email: !!(response.userDetails && response.userDetails.email),
          userID: response.userDetails ? response.userDetails.userID : null
        });
        self.handleGoNativeWithDetails(response.userDetails || {}, response.accessToken);
        return;
      }
      self.remoteLog('GONATIVE_STANDARD', {has_accessToken: false});
    } else {
      self.remoteLog('UNKNOWN_LOGIN_TYPE', {
        status: response ? response.status : null,
        type: response ? response.type : null
      });
    }

    if (accessToken) {
      self.remoteLog('CALLING_SETUSER', {userId: userId});
      self.setUser(accessToken, userId, function (response) {
        self.remoteLog('SETUSER_COMPLETE', {redirect_url: response.data.url});
        self.redirectCallback(response.data.url ? response.data.url : '/');
      })
    } else {
      self.remoteLog('NO_ACCESS_TOKEN', {});
      debugLog('facebook missing access token')
      pNotify('Non hai autorizzato completamente facebook oppure prova a cancellare la cache e riprovare', 'warning')
    }
  }

  /**
   * Gestisce il Limited Login di Facebook (iOS senza ATT)
   * I dati utente sono già nel JWT, non serve chiamare FB.api()
   */
  self.handleLimitedLogin = function (jwtPayload, authToken) {
    var payload = {
      id: jwtPayload.sub,
      email: jwtPayload.email,
      first_name: jwtPayload.given_name || jwtPayload.name,
      last_name: jwtPayload.family_name || '',
      provider_type: 'facebook',
      accessToken: authToken,
      limitedLogin: true,
      type: self.registerType(),
      invitationCode: self.invitationCode()
    }
    
    self.remoteLog('LIMITED_LOGIN_PAYLOAD', {
      id: payload.id,
      email: payload.email,
      first_name: payload.first_name,
      last_name: payload.last_name,
      has_accessToken: !!payload.accessToken
    });

    rest('POST', '/api/v2/facebook/bind', payload)
      .then(function (response) {
        self.remoteLog('LIMITED_LOGIN_BIND_RESPONSE', {
          success: response.success,
          status: response.status,
          has_url: response.data && response.data.url ? true : false
        });
        if (response.success) {
          self.user(response.data)
          pNotify('Accesso riuscito, attendi...', 'success')
          trovacigusto.loginRegisterModule.onesignalGetData()
        } else {
          self.notifyBindFailure(response)
        }
        self.loading(false)
        self.redirectAfterBind(response)
      })
      .catch(function (res) {
        self.remoteLog('LIMITED_LOGIN_BIND_ERROR', {error: res});
        debugLog(res)
        pNotify('Accesso non riuscito prova un altro metodo', 'warning')
      })
  }


  /**
   * Gestisce il login GoNative quando userDetails è già disponibile
   * Non serve chiamare FB.api() perché GoNative ha già fornito tutti i dati
   */
  self.handleGoNativeWithDetails = function (userDetails, accessToken) {
    // Parse name into first/last name
    var nameParts = (userDetails.name || "").split(" ");
    var firstName = nameParts[0] || "";
    var lastName = nameParts.slice(1).join(" ") || "";
    
    var payload = {
      id: userDetails.userID,
      email: userDetails.email,
      first_name: firstName,
      last_name: lastName,
      provider_type: "facebook",
      accessToken: accessToken,
      limitedLogin: false,
      type: self.registerType(),
      invitationCode: self.invitationCode()
    }
    
    self.remoteLog("GONATIVE_DETAILS_PAYLOAD", {
      id: payload.id,
      email: payload.email,
      first_name: payload.first_name,
      last_name: payload.last_name,
      has_accessToken: !!payload.accessToken
    });

    rest("POST", "/api/v2/facebook/bind", payload)
      .then(function (response) {
        self.remoteLog("GONATIVE_DETAILS_BIND_RESPONSE", {
          success: response.success,
          status: response.status,
          has_url: response.data && response.data.url ? true : false
        });
        if (response.success) {
          self.user(response.data)
          pNotify("Accesso riuscito, attendi...", "success")
          trovacigusto.loginRegisterModule.onesignalGetData()
        } else {
          self.notifyBindFailure(response)
        }
        self.loading(false)
        self.redirectAfterBind(response)
      })
      .catch(function (res) {
        self.remoteLog("GONATIVE_DETAILS_BIND_ERROR", {error: res});
        debugLog(res)
        pNotify("Accesso non riuscito prova un altro metodo", "warning")
      })
  }

  self.setUser = function (accessToken, userId, onSuccess) {
    // Dal ramo GoNative si arriva qui senza che l'SDK sia mai stato caricato: FB.api
    // lancerebbe ReferenceError.
    if (!window.tgFacebookSdk.ready) {
      self.withSdk(function () {
        self.setUser(accessToken, userId, onSuccess)
      })
      return
    }

    var url = '/me?fields=email,id,first_name,last_name,picture'
    if (userId)
      url = '/' + userId + '?fields=email,id,first_name,last_name,picture'

    self.remoteLog('FB_API_CALL', {url: url});

    FB.api(url, 'GET', {
      access_token: accessToken,
    }, function (response) {
      self.remoteLog('FB_API_RESPONSE', {
        has_error: !!response.error,
        error: response.error,
        id: response.id,
        email: response.email
      });

      // prima un'eccezione che nessuno raccoglieva: il pulsante sembrava non fare nulla
      if (response.error) {
        self.loading(false)
        pNotify('Facebook non ha risposto: riprova tra poco oppure accedi con email e password.', 'warning')
        return
      }

      var payload = {
        id: response.id,
        email: response.email,
        first_name: response.first_name,
        last_name: response.last_name,
        provider_type: 'facebook',
        accessToken: accessToken,
        type: self.registerType(),
        invitationCode: self.invitationCode()
      }

      rest('POST', '/api/v2/facebook/bind', payload)
        .then(function (response) {
          self.remoteLog('BIND_RESPONSE', {success: response.success, status: response.status});
          if (response.success) {
            self.user(response.data)
            pNotify('Accesso riuscito, attendi...', 'success')
            trovacigusto.loginRegisterModule.onesignalGetData()
          } else {
            self.notifyBindFailure(response)
          }
          self.loading(false)
          // si va avanti solo se il collegamento e' riuscito: altrimenti si resta sull'avviso
          if (self.bindSucceeded(response)) {
            onSuccess(response)
          }
        })
        .catch(function (res) {
          self.remoteLog('BIND_ERROR', {error: res});
          debugLog(res)
          pNotify('Accesso non riuscito prova un altro metodo', 'warning')
        })
    })
  }

  self.logout = function () {
    if (typeof FB === 'undefined') return

    FB.logout(function (response) {
      pNotify('Logout da facebook prova di nuovo ad accedere', 'warning')
      console.info('User canceled login or did not fully authorize.')
    })
  }

  self.checkStatus = function () {
    self.withSdk(function () {
      // FB.getLoginStatus risponde in modo asincrono: FB.login aperto nel suo callback
      // partirebbe fuori dal click e Safari bloccherebbe il popup. Si usa quindi lo stato
      // gia' in memoria (FB.getAuthResponse e' sincrono) e, se non c'e', si apre subito
      // il login, che gestisce anche chi ha gia' autorizzato il sito.
      var authResponse = FB.getAuthResponse()
      if (authResponse) {
        self.setUser(authResponse.accessToken, authResponse.userID, function (response) {
          self.redirectCallback(response.data.url ? response.data.url : '/');
        })
      } else {
        self.login()
      }
    })
  }

  self.unbindUser = function () {
    self.loading(true)
    rest('GET', '/api/v2/facebook/unbind')
      .then(function (response) {
        if (response.status === 'user.reset.password') {
          self.user(null)
          pNotify('Il tuo account Facebook è stato scollegato con successo. Se ancora non hai ancora creato una password devi impostarne una per poter accedere a Trovacigusto senza Facebook', 'warning')
        }
        self.loading(false)
      })
      .catch(function () {
        self.loading(false)
        pNotify('Si è verificato un errore. Prova a ricaricare la pagina e/o riprova più tardi', 'error')
      })
    self.logout()
  }

  self.bindUser = function () {
    self.withSdk(function () {
      FB.getLoginStatus(function (response) {
        self.facebookLoginCallback(response, function (response) {
          if (response)
            window.location.href = response
        })
      })
    })
  }

  self.bindPicture = function () {
    self.withSdk(function () {
      self.openLoginPopup(function (response) {
        if (response.authResponse) {
          FB.api('/me/picture?height=500&width=500&redirect=false', function (response) {
            if (!response.error) {
              self.loading(true)
              rest('POST', '/api/v2/facebook/image', { data: response.data })
                .then(function (response) {
                  if (response.success) {
                    self.image({ uri: response.data.image.uri })
                  } else {
                    pNotify('Si è verificato un errore durante il collegamento con Facebook. Prova a scollegarti e accedere di nuovo con Facebook', 'warning')
                  }
                  self.loading(false)
                })
            } else {
              pNotify('Si è verificato un errore durante il collegamento con Facebook. Prova a scollegarti e accedere di nuovo con Facebook', 'warning')
            }
          })
        }
      })
    })
  }

  return self
}
